import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Loader from '../../components/Loader';
import ProgressBarComp from './ProgressBar';
import GeneralInfo from './GeneralInfo';
import TabsSection from './TabsSection';
import apiUrl from '../../utils/apiUrl';
import BackButton from '../../components/BackButton';

const CampaignInfo = () => {
  const { id } = useParams();
  const [campaignData, setCampaignData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCampaignData = async () => {
      try {
        const response = await fetch(
          `${apiUrl.apiUrl}/programs/program/${id.replace(/_/g, '%20')}`
        );
        if (!response.ok) {
          throw new Error('Error fetching campaign info');
        }
        const data = await response.json();
        if (!data.data.program) {
          throw new Error('Campaign not found');
        }
        setCampaignData(data.data.program);
      } catch (error) {
        console.error('Error fetching campaign info:', error.message);
      } finally {
        setLoading(false);
      }
    };
    fetchCampaignData();
  }, [id]);

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div className='info-page campaign'>
          {campaignData ? (
            <>
              <BackButton />
              <ProgressBarComp
                goal={campaignData.totalGoal ? campaignData.totalGoal : 0}
                raised={campaignData.totalRaised}
                donors={campaignData.totalDonors}
              />
              <div className='container'>
                <GeneralInfo campaignData={campaignData} />
                <TabsSection campaignData={campaignData} />
              </div>
            </>
          ) : (
            <h1>Sin información suficiente para mostrar</h1>
          )}
        </div>
      )}
    </>
  );
};

export default CampaignInfo;
